import attViewerImageView from './attViewerImageComponent.html';
import './attViewerImageComponent.css';
import { AuthTypes } from 'components/sharpr/auth/AuthTypes';

export function attViewerImageComponent() {
	return {
		bindings: {
			attachment: '<',
		},
		controllerAs: 'vm',
		controller: attViewerImageComponentCtrl,
		template: attViewerImageView,
	};
}

export class attViewerImageComponentCtrl {
	constructor($element, $timeout, storage) {
		'ngInject';
		this.$element = $element;
		this.$timeout = $timeout;
		this.storage = storage;
		this.checkIfEnlargable = this.checkIfEnlargable.bind(this);
	}

	$onInit() {
		window.addEventListener('resize', this.checkIfEnlargable);
	}

	$onChanges() {
		const urlParam = AuthTypes.getUrlParam('', this.storage);
		const url = `${window.BASE_URL}/api/v2/files/${this.attachment.id}/download?disposition=inline&${urlParam}`;
		// show loader while image is loading
		this.backgroundSizing = '16px 16px';
		this.url = '/assets/img/loader-responsive-light.gif';
		// wait until image is loaded
		const img = new Image();
		img.src = url;
		img.onload = () => {
			this.url = url;
			this.backgroundSizing = 'contain';
			this.width = img.width;
			this.height = img.height;
			this.checkIfEnlargable();
			this.$timeout(() => {});
		};
	}

	$onDestroy() {
		window.removeEventListener('resize', this.checkIfEnlargable);
	}

	checkIfEnlargable() {
		this.isEnlargable = this.width > this.$element[0].clientWidth || this.height > this.$element[0].clientHeight;
	}

	enlarge() {
		const html = `
			<!DOCTYPE html>
			<body><img src="${this.attachment.url}"></body>
		`;
		const win = window.open('about:blank', '');
		win.document.write(html);
		win.document.close();
	}
}
